import * as React               from "react";
import { Component, ReactNode } from "react";
import { connect }              from "react-redux";
import { Dispatch }             from "redux";
import GlobalDispatcher         from "../../infrastructure/redux/global/GlobalDispatcher";
import ResKaHeader              from "../components/header/ResKaHeader";

interface Props {
  headerTitle: string;
  dispatcher: GlobalDispatcher;
}

class HeaderContainer extends Component<Props> {
  public render(): ReactNode {
    const {headerTitle, dispatcher} = this.props;
    return (
      <>
        <ResKaHeader headerTitle={ headerTitle } dispatcher={ dispatcher }/>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    dispatcher: new GlobalDispatcher(dispatch),
  }
};

export default connect(null, mapDispatchToProps)(HeaderContainer);